import { Col, Container, Form, Row } from "react-bootstrap";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../selectors/auth";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import _ from "lodash";
import { React, useEffect, useState } from "react";
import { useHistory } from "react-router";
import clsx from "clsx";
import ActionCustomTable from "./components/ActionCustomTable";
import ActionCustomDetailModal from "./modal/ActionCustomDetailModal";
import PaymentHistoryDetailModal from "./modal/PaymentHistoryDetailModal";
function ActivityLog({}) {
  const [token, setToken] = useState(null);
  const [show, setShow] = useState(false);
  const [type, setType] = useState(null);
  const [time_frame, set_time_frame] = useState('this_month');
  const history = useHistory()
  const [loading, setLoading] = useState(false);
  const [itemModalVisible, setItemModalVisible] = useState(false);
  const [paymentItemModalVisible, setPaymentItemModalVisible] = useState(false);
  const [targetItem, setTargetItem] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const dispatch = useDispatch();

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const { data,isLoading,refetch } = useQuery({
    queryKey: ["activity-log", time_frame],
    queryFn: async () => {
      try {
        return await axiosInstance.get(
          `clientarea/activity-log?time_frame=${time_frame}`,
        );
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    placeholderData: keepPreviousData,
    enabled: !_.isEmpty(token),
  });

  const setOffData = _.get(data,['data','offset'],[])
  const ipoData = _.get(data,['data','ipo'],[])
  const withdrawData = _.get(data,['data','withdraw'],[])
  const paymentData = _.get(data,['data','payment'],[])
  const depositData = _.get(data,['data','deposit'],[])

  const onClickViewItemDetail = (data,isPayment=false) => {
    setTargetItem(data)
    if(isPayment){
      setPaymentItemModalVisible(true)
    }
    else {
      setItemModalVisible(true)
    }
  }

  const onCloseViewItemModal = () => {
    setTargetItem(null)
    setItemModalVisible(false)
    setPaymentItemModalVisible(false)

  }

  const onClickDelete = async (url,type) => {
    const confirmed = window.confirm("Are you sure you want to cancel this item?");
    if (!confirmed) {
      return;
    }
    setLoading(true);
    setType(type)
    try {
      const result = await axiosInstance.del(`${url}`);
      await refetch()
      setItemModalVisible(false)
      setPaymentItemModalVisible(false)
      setTargetItem(null)
      return result;
    } catch (e) {
    } finally {
      setLoading(false);
      setType(null)
    }
  };

  const onClickViewDocument = async (url) => {
    try {
      const res = await fetch(url.replace("http", "https").replace("httpss", "https"), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // Here you can set any headers you want
        },
      });
      const blob = await res.blob();

      const urlObject = URL.createObjectURL(blob);
      window.open(urlObject, "_links");
    } catch (e) {
      console.log("ee" + e);
    } finally {
    }
  };

  const onClickHistory =  (id)=> {
    history.push(`/dashboard/e-ipo/history/${id}`);

  }

  return (
    <Container fluid>
      {/*=========== Client Info ============*/}
      <div className="mt-0">
      <div className="primary-border-table-border">
        <div
            className={clsx(
                "custom-card-label-container d-flex justify-content-between align-items-center",
            )}
          >
            <h2>Activity Details</h2>
            <div>
              <Form.Select className="formControl" style={{minWidth: '150px'}} aria-label="Default select" value={time_frame} onChange={(e)=>{set_time_frame(e.target.value)}}>
                <option value="last_7_days">Last 7 Days</option>
                <option value="last_2_week">Last 2 Weeks</option>
                <option value="this_month">This Month</option>
                <option value="last_3_month">Last 3 Months</option>
              </Form.Select>
            </div>
          </div>
          <div className="px-3 py-4 activity-title">
            <h2>IPO</h2>
            <ActionCustomTable type='ipo' isDeleteLoading={loading && type ==='ipo'} onClickDelete={onClickDelete} loading={isLoading} onClickViewDetail={onClickHistory} data={ipoData}></ActionCustomTable>
            <h2>Setoff</h2>
            <ActionCustomTable type='setoff' isDeleteLoading={loading && type ==='setoff'} onClickDelete={onClickDelete} loading={isLoading} onClickViewDetail={onClickViewItemDetail} data={setOffData}></ActionCustomTable>
            <h2>Payment</h2>
            <ActionCustomTable type='payment' isDeleteLoading={loading && type ==='payment'} onClickDelete={onClickDelete} isPayment={true}  loading={isLoading} onClickViewDetail={onClickViewItemDetail} data={paymentData}></ActionCustomTable>
            <h2>Withdraw</h2>
            <ActionCustomTable type='withdraw' isDeleteLoading={loading && type ==='withdraw'} onClickDelete={onClickDelete} loading={isLoading} onClickViewDetail={onClickViewItemDetail} data={withdrawData}></ActionCustomTable>
            <h2>Deposit</h2>
            <ActionCustomTable type='deposit' isDeleteLoading={loading && type ==='deposit'} onClickDelete={onClickDelete} isPayment={true} loading={isLoading} onClickViewDetail={onClickViewItemDetail} data={depositData}></ActionCustomTable>
          </div>
        </div>
      </div>
      <ActionCustomDetailModal show={itemModalVisible} data={targetItem} loading={loading} onClickDeleteFunction={onClickDelete} handleClose={onCloseViewItemModal}
      ></ActionCustomDetailModal>
      <PaymentHistoryDetailModal loading={loading} onClickViewDocument={onClickViewDocument}  onClickDeleteFunction={onClickDelete} handleClose={onCloseViewItemModal} data={targetItem} show={paymentItemModalVisible} ></PaymentHistoryDetailModal>
    </Container>
  );
}

export default ActivityLog;
